window.EditarEnderecoOrcamentoController = ControllerBase.extend({
    name: "EditarEnderecoOrcamentoController",

    framework: "knockout",

    ajax: function() {

        return {
            url: "/Orcamento/_EditarEndereco",
            type: "post",
            cache: false,
            data: {
                clienteNaoCadastrado: this.clienteNaoCadastrado
            }
        };
    },

    newModel: function() {

        return {
            Tipo: 6,
            DescricaoClassificacoes: null,
            Classificacoes: [],
            Cep: null,
            Logradouro: null,
            Numero: null,
            Complemento: null,
            Bairro: null,
            Referencia: null,
            CodigoEstado: null,
            SiglaUf: null,
            CodigoCidade: null,
            NomeCidade: null,
            Novo: true,
            selecionado: false
        };
    },


    antesRenderizacaoCompleta: function(region) {

        if (!region) {
            return;
        }

        if (!this.model.Codigo || !this.model.Codigo()) {
            region.$el.attr("breadcrumb", "Novo Endereço");
        }
    },

    antesBinding: function() {

        if (this.model.CodigoCidade && this.model.CodigoCidade()) {
            this.codigoCidade = this.model.CodigoCidade();
        }

        if (this.model.NomeCidade && this.model.NomeCidade()) {
            this.nomeCidade = this.model.NomeCidade();
        }

    },

    aposBinding: function () {
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },


    renderizado: function() {


    },

    formConfig: {
        selector: "#form-editar-endereco-orcamento",
        submit: {
            selector: "#salvar-endereco-orcamento",
            loadingText: "Aguarde...",
            callback: "salvar",
            type: "model",
            modelType: "knockout"
        },
        rules: {
            'Logradouro': {
                required: true
            },
            'Numero': {
                required: true
            },
            'Bairro': {
                required: true
            },
            'Uf': {
                required: true
            },
            'Cidade': {
                required: true
            },
        },
        messages: {
            'Logradouro': {
                required: 'O campo "Logradouro" é obrigatório.'
            },
            'Numero': {
                required: 'O campo "Número" é obrigatório.'
            },
            'Bairro': {
                required: 'O campo "Bairro" é obrigatório.'
            },
            'Uf': {
                required: 'O campo "UF" é obrigatório.'
            },
            'Cidade': {
                required: 'O campo "Cidade" é obrigatório.'
            }
        }

    },


    listarCidades: function(codigoEstado) {

        if (!codigoEstado) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Comum/ListarCidadesPorEstado",
            type: "post",
            data: {
                codigoEstado: codigoEstado
            },
            success: function(data) {
                self.model.cidades(data);

                if (self.codigoCidade) {
                    self.model.CodigoCidade(self.codigoCidade);
                    self.codigoCidade = null;
                }

                if (self.nomeCidade) {
                    self.model.NomeCidade(self.nomeCidade);
                    self.nomeCidade = null;
                }

            }
        });

    },

    obterEnderecoCep: function(e) {

        if (!e) {
            return;
        }

        if (e.preventDefault) {
            e.preventDefault();
        }

        var cep = e.target ? $(e.target).val() : this.model.Cep();

        enderecoController.obterEnderecoPorCep(cep, $.proxy(this.preencherEndereco, this));

    },

    preencherEndereco: function(data) {

        if (!data) {
            return;
        }

        this.model.Logradouro(data.Logradouro);
        this.model.Bairro(data.Bairro);
        this.codigoCidade = data.Cidade.Codigo;
        this.nomeCidade = data.Cidade.Nome;

        if (this.model.CodigoEstado() == data.Estado.Codigo) {

            this.model.CodigoCidade(this.codigoCidade);
            this.codigoCidade = null;

        } else {
            this.model.CodigoEstado(data.Estado.Codigo);
            this.model.SiglaUf(data.Estado.Sigla);
        }
    },

    obterDescricaoClassificacoesSelecionados: function() {


        var selecionados = $("select[name=Classificacoes] option:selected");

        var classificacoes = "";
        var sep = "";

        $.each(selecionados,
            function() {

                classificacoes = classificacoes + sep + $(this).text();

                if (sep == "") {
                    sep = ", ";
                }

            });

        if (classificacoes) {

            if (!this.model.DescricaoClassificacoes) {
                this.appendToModel({ name: "DescricaoClassificacoes", value: classificacoes });
            } else {
                this.model.DescricaoClassificacoes(classificacoes);
            }

        }
    },

    obterSiglaUf: function() {

        var siglaUf = $("select[name=Uf] option:selected", this.region.$el).text();

        if (siglaUf) {

            if (!this.model.SiglaUf) {
                this.appendToModel({ name: "SiglaUf", value: siglaUf });
            } else {
                this.model.SiglaUf(siglaUf);
            }
        }

    },

    obterNomeCidade: function() {

        var cidade = $("select[name=Cidade] option:selected", this.region.$el).text();

        if (cidade) {

            if (!this.model.NomeCidade) {
                this.appendToModel({ name: "NomeCidade", value: cidade });
            } else {
                this.model.NomeCidade(cidade);
            }
        }

    },

    salvar: function(data, e) {

        e.preventDefault();

        if (this.editando) {
            this.endereco.Classificacoes(data.Classificacoes());
            this.endereco.DescricaoClassificacoes(data.DescricaoClassificacoes());
            this.endereco.Cep(data.Cep());
            this.endereco.Logradouro(data.Logradouro());
            this.endereco.Numero(data.Numero());
            this.endereco.Complemento(data.Complemento());
            this.endereco.Bairro(data.Bairro());
            this.endereco.Referencia(data.Referencia());
            this.endereco.CodigoEstado(data.CodigoEstado());
            this.endereco.SiglaUf(data.SiglaUf());
            this.endereco.CodigoCidade(data.CodigoCidade());
            this.endereco.NomeCidade(data.NomeCidade());
        }


        if (this.enderecoEditadoCallback) {
            this.enderecoEditadoCallback(data);

        }

    }

});